import { toast } from '@fielded/shared-ui/src/components/Page'
import { isNetworkError } from '../../../van-shared/utils/isNetworkError'

export const displayWarningToast = (error) => {
  const commonToastProps = {
    type: 'warning',
    autoDismiss: false
  }

  if (isNetworkError(error)) {
    return toast({
      ...commonToastProps,
      title: "You're offline. Please check your internet connection."
    })
  }

  toast({
    ...commonToastProps,
    title: error.message
  })
}
